import { render, staticRenderFns } from "./UCSAOrderList.vue?vue&type=template&id=78dd658c&"
import script from "./UCSAOrderList.vue?vue&type=script&lang=js&"
export * from "./UCSAOrderList.vue?vue&type=script&lang=js&"
import style0 from "./UCSAOrderList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports